import PropTypes from "prop-types";
import * as React from "react";
import { Button, Dialog } from "../../themeV2";

const ConfirmDialog = function ConfirmDialog({
  open,
  title,
  description,
  confirmLabel,
  cancelLabel = "Cancel",
  destructive = false,
  onConfirm,
  onCancel,
}) {
  return (
    <Dialog.Root alert open={open} onOpenChange={(next) => !next && onCancel()}>
      <Dialog.Popup size="sm">
        <Dialog.Title>{title}</Dialog.Title>
        <Dialog.Description>{description}</Dialog.Description>
        <Dialog.Actions>
          <Button variant="text" onClick={onCancel}>
            {cancelLabel}
          </Button>
          <Button
            variant="filled"
            color={destructive ? "error" : "primary"}
            onClick={onConfirm}
          >
            {confirmLabel}
          </Button>
        </Dialog.Actions>
      </Dialog.Popup>
    </Dialog.Root>
  );
};

ConfirmDialog.propTypes = {
  cancelLabel: PropTypes.string,
  confirmLabel: PropTypes.string.isRequired,
  description: PropTypes.node.isRequired,
  destructive: PropTypes.bool,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
};

export default ConfirmDialog;
